import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { SharedService } from 'app/modules/common/services/shared-service';
import { ActuationService } from '../../services/actuation.service';

@Component({
    selector: 'app-edit-actuaciones',
    templateUrl: './edit-actuaciones.component.html',
    styleUrls: ['./edit-actuaciones.component.scss'],
    standalone: false
})
export class EditActuacionesComponent implements OnInit {

  public ActionEditForm: UntypedFormGroup;
  public ActionId: number;
  public LeaveId: number;

  constructor(
    public dialogRef: MatDialogRef<EditActuacionesComponent>,
    private formBuilder: UntypedFormBuilder,
    private sharedService: SharedService,
    private actuacioneService: ActuationService) { }

  ngOnInit(): void {
    this.InitForm();
    this.SetFormValues();
  }

  private InitForm(): void {
    this.ActionEditForm = this.formBuilder.group({
      ActionId: [null, Validators.required],
      Text: [null]
    });
  }

  private SetFormValues(): void {
    this.actuacioneService.GetActuationText(this.ActionId).subscribe(res => {
      if (res.code === 0) {
        this.ActionEditForm.patchValue({
          ActionId: this.ActionId,
          Text: res.result
        });
      }
    }, error => {
      console.error(error);
    });
  }

  public Close(): void {
    this.dialogRef.close();
  }

  public SaveActionText(): void {
    if (this.ActionEditForm.valid) {
      const actionId = this.ActionEditForm.get('ActionId').value;
      this.actuacioneService.UpdateActuationText(actionId, this.ActionEditForm.value).subscribe(res => {
        if (res.code === 0) {
          this.sharedService.ShowSnackBar('Texto de actuación guardado correctamente');
          this.actuacioneService.PublishActuations(this.LeaveId);
          this.Close();
        } else {
          this.sharedService.ShowSnackBar('No se pudo guardar el texto de la actuación');
        }
      }, error => {
        this.sharedService.ShowSnackBar('No se pudo guardar el texto de la actuación');
        console.error(error);
      });
    }
  }

}
